<script>
import { defineComponent } from 'vue';
import columns from '@/pages/promotions/giftCardCodes/columns';
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import GiftCardCodes from '@/pages/promotions/giftCardCodes/Gift-card-codes.vue';
import PromoCategories from '@/pages/promotions/promoCategories/Promo-categories.vue';
import PromoAds from '@/pages/promotions/promoAds/Promo-ads.vue';
import PromoTemplates from '@/pages/promotions/promoTemplates/Promo-templates.vue';
import PromoCodes from '@/pages/promotions/promoCodes/Promo-codes.vue';

const PROMOTIONS = {
  categories: {
    title: 'Promo Categories',
    key: 'promoCategories',
  },
  codes: {
    title: 'Promo Codes',
    key: 'codes',
  },
  ads: {
    title: 'Promotional Ads',
    key: 'ads',
  },
  templates: {
    title: 'Ad Templates',
    key: 'templates',
  },
  giftCardCodes: {
    title: 'Gift Card Codes',
    key: 'giftCardCodes',
  },
};

export default defineComponent({
  components: {
    PageHeader,
    GiftCardCodes,
    PromoCategories,
    PromoAds,
    PromoTemplates,
    PromoCodes,
  },
  data() {
    return {
      title: 'Promo Codes',
      key: 'codes',
      columns: columns(),
      promotions: PROMOTIONS,
      checkedCategory: 0,
    };
  },
  methods: {
    selectTab(title, key) {
      this.title = title;
      this.key = key;
    },
  },
  mounted() {
    this.selectTab(this.title, this.key);
  },
  watch: {
    checkedCategory(newV) {
      if (newV) {
        this.title = 'Promo Codes';
        this.key = 'codes';
      }
    },
  },
});
</script>

<template>
  <div class="promo-page">
    <page-header :title="title"/>
    <div class="buttons-menu">
      <div
          class="buttons-menu-item"
          v-for="promotion in promotions"
          :key="promotion.key"
      >
        <a-button
            @click="selectTab(promotion.title, promotion.key)"
        >
          {{ promotion.title }}
        </a-button>
      </div>
    </div>
    <promo-codes v-if="key === 'codes'" :checked-category="checkedCategory"/>
    <promo-ads v-else-if="key === 'ads'"/>
    <promo-categories
        v-else-if="key === 'promoCategories'"
        v-model:checked-category="checkedCategory"
    />
    <promo-templates v-else-if="key === 'templates'"/>
    <gift-card-codes v-else-if="key === 'giftCardCodes'"/>
  </div>
</template>

<style scoped lang="scss">
.promo-page {
  position: relative;
}

.buttons-menu {
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 0;
  right: 0;
}
.buttons-menu-item {
  margin: 25px;
}
</style>
